import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ListYourProperty.less';

export class ListYourProperty extends React.Component {
    static propTypes = {
        isInverse: PropTypes.bool,
        text: PropTypes.string.isRequired,
    };

    static defaultProps = {
        isInverse: false,
    };

    get attrs() {
        return {
            className: this.className,
            'data-bypass': true,
            href: this.props.link,
        };
    }

    get className() {
        return classNames(
            'site-header-list-your-property',
            'btn', 'btn-default', 'btn-sm',
            this.props.isInverse && 'btn-inverse',
        );
    }

    render() {
        return (
            <a {...this.attrs} target="_blank">{this.props.text}</a>
        );
    }
}
